var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.09,165.92H35.89a8.71,8.71,0,0,1-8.83-8.55V30.05a8.71,8.71,0,0,1,8.83-8.55h74L146,56.57v64.67h-4.15V58.33L108.23,25.66H35.89a4.55,4.55,0,0,0-4.68,4.39V157.37a4.55,4.55,0,0,0,4.68,4.39h85.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.94,59.1H109.05A2.08,2.08,0,0,1,107,57V23.58a2.08,2.08,0,0,1,4.16,0V55h32.81a2.08,2.08,0,1,1,0,4.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.92,62.5H42.08a2.08,2.08,0,0,1,0-4.16H82.92a2.08,2.08,0,0,1,0,4.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.87,92.94H42.08a2.08,2.08,0,0,1,0-4.16h87.79a2.08,2.08,0,0,1,0,4.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.87,115H42.08a2.08,2.08,0,1,1,0-4.16h87.79a2.08,2.08,0,0,1,0,4.16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.85,120.32a29.09,29.09,0,1,0,29.09,29.09A29.08,29.08,0,0,0,143.85,120.32Zm17.59,27.42a4.68,4.68,0,0,1-6.61,0l-6.64-6.64v27.31a4.68,4.68,0,0,1-9.35,0V141.78l-6,6a4.68,4.68,0,1,1-6.62-6.62l14-14a4.64,4.64,0,0,1,3.31-1.38,1.27,1.27,0,0,1,.27,0,4.6,4.6,0,0,1,3.56,1.36l14,14a4.68,4.68,0,0,1,0,6.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInvoice);
export default __webpack_public_path__ + "static/media/open-invoice.a8b0f4449c390eb5347f6b9966c87eac.svg";
export { ForwardRef as ReactComponent };